const requested = new WeakMap<HTMLInputElement,string>();
export async function applyStakePolicy(client: {getCurrencyPolicy(currency: string): Promise<any>}, input: HTMLInputElement | null, currency: string) {
  if (!input || requested.get(input)===currency) return;
  requested.set(input,currency);
  try {
    const policy=await client.getCurrencyPolicy(currency);
    if (!input.isConnected || requested.get(input)!==currency || policy.currency!==currency) return;
    input.min=policy.min_stake;input.max=policy.max_stake;
    input.title=`Stake in ${currency}: ${policy.min_stake} – ${policy.max_stake}. Display conversion does not change the stake.`;
    // Preserve the user's entered amount. Native validity and the backend enforce the range.
    input.setCustomValidity('');
  } catch { if(requested.get(input)===currency) {input.setCustomValidity('Authoritative stake policy unavailable');requested.delete(input);} }
}
